import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import React from 'react';
import { connect } from "react-redux";
import Details from './Details.js'
import PosProstor from './PosProstor.js'
import NapUredaj from './NapUredaj.js'
import Artikli from './Artikli.js'
import Users from './Users.js'
import './tabs.scss';

export class TabContainer extends React.Component{
    render(){  

        return(
            <div className="dashboardTabsAdmin">
                <Tabs>
                    <TabList>
                        <Tab>Općenito</Tab>   
                        <Tab>Poslovni prostor</Tab>   
                        <Tab>Naplatni uređaji</Tab>  
                        <Tab>Artikli </Tab> 
                        <Tab>Korisnici </Tab> 
                    </TabList>
                    <hr style={{padding: "0px",
                        margin: "0px",
                        border: "1px solid #808080"}}
                    />
                    <TabPanel>
                        <Details />
                    </TabPanel>   
                    <TabPanel>
                        <PosProstor />
                    </TabPanel>   
                    <TabPanel>
                        <NapUredaj />
                    </TabPanel>  
                    <TabPanel>
                        <Artikli />
                    </TabPanel>   
                    <TabPanel>
                        <Users />
                    </TabPanel>            
                </Tabs>
            </div>
        )
    };
};

const mapStateToProps = state => {
    return {      
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
  };
  
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(TabContainer);
